import { ReportModule } from './report/report.module';
import { AuthModule } from './auth/auth.module';
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { JwtHelperService, JwtInterceptor, JwtModule } from '@auth0/angular-jwt';
import { environment } from '../environments/environment';
import { AuthService } from './auth/auth-service.service';
import { RefreshTokenInterceptor } from './auth/refresh-token-interceptor';

import {
    NbChatModule,
    NbDatepickerModule,
    NbDialogModule,
    NbMenuModule,
    NbSidebarModule,
    NbToastrModule,
    NbWindowModule,
    NbCardModule,
    NbGlobalPhysicalPosition
} from '@nebular/theme';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ReloadOnChangeComponent } from './reload-on-change.component';
import { LocalizationModule } from './@core/localization/localization.module';
import { MissingTranslationHandler, MissingTranslationHandlerParams, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { StaticTranslationLoader } from './static-translations-loader';

export function tokenGetter() {
    return localStorage.getItem(environment.DEFAULT_TOKEN_NAME);
}

export class MyMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {
        console.log(params);
        return params.translateService.instant('ALGEMEEN.GEEN_VERTALING', { tag: params.key });
    }
}

import { APP_INITIALIZER, ApplicationConfig, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from "@sentry/angular";

@NgModule({
    declarations: [AppComponent, ReloadOnChangeComponent],
    bootstrap: [AppComponent],
    imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        NbSidebarModule.forRoot(),
        NbMenuModule.forRoot(

        ),
        NbDatepickerModule.forRoot(),
        NbDialogModule.forRoot(),
        NbWindowModule.forRoot(),
        NbToastrModule.forRoot({
            position: NbGlobalPhysicalPosition.BOTTOM_RIGHT,
        }),
        NbCardModule,
        NbChatModule.forRoot({
            messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
        }),
        CoreModule.forRoot(),
        ThemeModule.forRoot(),
        AuthModule,
        ReportModule,
        JwtModule.forRoot({
            config: {
                tokenGetter: tokenGetter,
                allowedDomains: environment.whitelistedDomains,
                disallowedRoutes: environment.blacklistedRoutes,
            }
        }),
        ReactiveFormsModule,
        FormsModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                //useFactory: (createTranslateLoader),
                //deps: [HttpClient],
                useClass: StaticTranslationLoader
            },
            missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
            isolate: false,
            defaultLanguage: "nl",
        })
    ],
    providers: [
        { provide: APP_BASE_HREF, useValue: '/' },
        AuthService,
        JwtHelperService,
        JwtInterceptor,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RefreshTokenInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => { },
            deps: [Sentry.TraceService],
            multi: true,
        },
    ]
})
export class AppModule {
}
